import React from 'react';

import type { CogsComponentProps } from '@cognite/cogs-utils-v11';

export interface RowProps extends CogsComponentProps<
  'children',
  never,
  {
    className?: string;
    gap?: number;
    cols?: number;
    auto?: number;
    element?: keyof React.ReactHTML;
  }
> {
  className?: string;
  gap?: number;
  cols?: number;
  auto?: number;
  element?: keyof React.ReactHTML;
}

export const Row: React.FC<RowProps> = ({
  children,
  className,
  gap = 8,
  cols = 24,
  auto,
  element = 'div',
  ...rest
}: RowProps) => {
  const extendedClassName = ['cogs-v11', 'cogs-row', className]
    .filter(Boolean)
    .join(' ');

  const style = {
    gridTemplateColumns: `repeat(${cols}, 1fr)`,
    gridGap: gap,
  };

  if (auto) {
    style.gridTemplateColumns = `repeat(auto-fill, minmax(${auto}px, 1fr))`;
  }

  return React.createElement(
    element,
    {
      ...rest,
      className: extendedClassName,
      style: {
        ...(rest.style || {}),
        ...style,
      },
    },
    children
  );
};
